import type {DateValue} from '@internationalized/date';
import {getLocalTimeZone, fromDate} from '@internationalized/date';
import {getDateFormatString} from '@utils';
import {format, formatISO} from 'date-fns';

// TODO: check why we get value undefined expecting DateValue from typescript

export const calendarDateFormatter = (value: DateValue): string => {
  if (!value) return `N/A`;
  // Extract year, month, day directly from DateValue to avoid timezone conversion issues.
  // When a DateValue is created from a string like "2024-09-12", it may be interpreted as UTC.
  // Using toDate(getLocalTimeZone()) would convert UTC to local time, causing dates to shift
  // backward in western timezones (e.g., Sept 12 UTC midnight becomes Sept 11 in US timezones).
  // Instead, we format directly from the DateValue's year/month/day components.
  const year = value.year;
  const month = value.month;
  const day = value.day;

  // Create a local date at noon to avoid any DST edge cases
  const localDate = new Date(year, month - 1, day, 12, 0, 0);
  return format(localDate, getDateFormatString());
};

export const dateFormatter = (value: Date | string, dateFormat?: string): string => {
  if (!value) return `N/A`;
  const a = value instanceof Date ? fromDate(value, getLocalTimeZone()) : fromDate(new Date(value), getLocalTimeZone());
  const dateStringFormat = dateFormat ?? getDateFormatString();
  return value ? format(a.toDate(), dateStringFormat) : `N/A`;
};

export const formatDateToISO = (date: Date): string => {
  return formatISO(date, {representation: `date`});
};
